import React, { useEffect, useState } from "react";
import { ComboBox, FormSection } from "../../../components";

export default function FormPesquisaPorOutrosDados({
  // initialConsulta,
  genotipados,
  classificarPor,
  ordem,
  numeroPagina,
  handleConsulta,
}) {
  const [consulta, setConsulta] = useState("");
  const [dropdownGenotipado, setDropdownGenotipado] = useState(false);
  const [inputDropdownGenotipado, setInputDropdownGenotipado] = useState("");
  const [dropdownClassificarPor, setDropdownClassificarPor] = useState(false);
  const [
    inputDropdownClassificarPor,
    setInputDropdownClassificarPor,
  ] = useState("MGT");
  const [dropdownEmOrdem, setDropdownEmOrdem] = useState(false);
  const [inputDropdownEmOrdem, setInputDropdownEmOrdem] = useState("DESC");
  const [dropdownNumeroPagina, setDropdownNumeroPagina] = useState(false);
  const [inputDropdownNumeroPagina, setInputDropdownNumeroPagina] = useState(
    "15"
  );

  const [depsOpen, setDepsOpen] = useState(true);

  const handleInputGenotipado = (value) => {
    setInputDropdownGenotipado(value.value);
    setConsulta({ ...consulta, genotipados: value.key });
  };

  const handleInputClassificarPor = (value) => {
    setInputDropdownClassificarPor(value.value);
    setConsulta({ ...consulta, campoOrdem: value.key });
  };

  const handleInputEmOrdem = (value) => {
    setInputDropdownEmOrdem(value.value);
    setConsulta({ ...consulta, Ordem: value.key });
  };

  const handleInputNumeroPagina = (value) => {
    setInputDropdownNumeroPagina(value.value);
    setConsulta({ ...consulta, AnimaisPorPagina: value.key });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  return (
    <div className="main-content">
      <FormSection title="Pesquisa Por Outros Dados" borderBottomWidth={369}>
        <ComboBox
          items={genotipados}
          displayName="value"
          label="Genotipados"
          placeholder="Selecione"
          handleInput={(item) => handleInputGenotipado(item)}
        />

        <ComboBox
          items={classificarPor}
          displayName="value"
          label="Classificar Por"
          placeholder="Selecione"
          handleInput={(item) => handleInputClassificarPor(item)}
        />

        <ComboBox
          items={ordem}
          displayName="value"
          label="Em Ordem"
          placeholder="Selecione"
          handleInput={(item) => handleInputEmOrdem(item)}
        />

        <ComboBox
          items={numeroPagina}
          displayName="value"
          label="Animais por Página"
          placeholder="Selecione"
          handleInput={(item) => handleInputNumeroPagina(item)}
        />
      </FormSection>
    </div>
  );
}
